export default __webpack_public_path__ + "static/media/BA98N.01a2b348.svg";